<template>
	<div
		:id="labelId"
		class="c-Label">
		<span
			class="c-Label__text"
			:class="labelClassObj">
			{{ value }}
		</span>
		<Tooltip
			v-if="hasTooltip"
			:message="tooltipValue"
			:position="'top'"
			:anchor-name="labelId">
		</Tooltip>
	</div>
</template>

<script>
import Tooltip from '../Tooltip/Tooltip.vue';
import { randomizeId } from '../../utils/utils';

export default {
  name: 'Label',
  components: {
    Tooltip
  },
	props: {
		/**
     * Label type
     * @values is-bold, is-subtle
     */
		labelType: {
			type: String,
			required: false,
			default: 'is-bold',
			validator(type) {
				return [
					'is-bold',
					'is-subtle',
				].includes(type);
			},
    },
   	/**
     * Label style (colors)
     * @values is-info, is-inverted, is-success, is-attention, is-error
     */
    labelStyle: {
			type: String,
			required: false,
			default: 'is-info',
			validator(type) {
				return [
					'is-info',
					'is-inverted',
					'is-success',
					'is-attention',
					'is-error',
				].includes(type);
			},
    },
		/**
     * the Label value
     */
		value:{
			type: String,
      required: true,
      default: '',
    },
 		/**
     * the Label's tooltip value
     */
		tooltipValue:{
			type: String,
      required: false,
      default: '',
		},
	},
  data() {
		return {
      labelId: randomizeId('labelid')
		};
	},
  computed: {
    hasTooltip() {
      return this.tooltipValue !== '';
    },
		labelClassObj() {
			return {
				'is-info': this.labelStyle === 'is-info',
				'is-inverted': this.labelStyle === 'is-inverted',
				'is-success': this.labelStyle === 'is-success',
				'is-attention': this.labelStyle === 'is-attention',
        'is-error': this.labelStyle === 'is-error',
        'is-bold': this.labelType === 'is-bold',
        'is-subtle': this.labelType === 'is-subtle',
      };
    },
	},
}
</script>

<style lang="scss" scoped>
@import '../../scss/variables.scss';

.c-Label {
  display: inline-flex;
  justify-content: center;
  align-items: center;

  &__text{
    max-width: 196px;
    border-radius: $border-radius;
    margin: 0;
    padding: 0 8px;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 1.25px;
    line-height: 24px;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;

    text-transform: uppercase;
    animation: fadeInAnimation ease 1s;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;

    @keyframes fadeInAnimation {
      0% {
          opacity: 0;
      }
      100% {
          opacity: 1;
      }
    }


    &.is-info {
      background-color: $un-blue;
      color: $un-white;
      
      
      &.is-subtle {
        background-color: $un-blue-light;
        color: $un-blue;
      }
    }

    &.is-inverted {
      background-color: $un-white;
      color: $un-gray-bd;
      
      &.is-subtle {
        background-color: $un-n50;
      }
    }

    &.is-attention {
      background-color: $un-yellow;
      color: $un-gray-bd;

      &.is-subtle {
        background-color: $un-yellow-lighter;
      }
    }

    &.is-success {
      background-color: $un-green;
      color: $un-gray-bd;
      
      &.is-subtle {
        background-color: $un-green-lighter;
        color: $un-green-darker;
      }
    }

    &.is-error {
      background-color: $un-red;
      color: $un-white;
      
      &.is-subtle {
        background-color: $un-red-lighter;
        color: $un-red-darker;
      }
    }
  }
}
</style>